import { createSelector } from "reselect";
import { populationPrevalenceChartDataSelector } from "../population_prevalence_chart_data_selector";

export const populationPrevalenceChartDataDataSelector = createSelector(
  populationPrevalenceChartDataSelector,
  chartData => {
    return chartData.data;
  }
);
